// import { t } from "i18next";
import React from "react";
import { Icon } from "@iconify/react";
import { Link, Route } from "react-router-dom";
import {
  img_url2,
  img_url3,
  img_url4,
  img_url5,
  img_url6,
  img_url7,
  img_url8,
  VIEW_TEMPLE,
  img_url9,
  img_url10,
  BADRI_NATH,
} from "../Constant/Constants";
// import Footer from "../Footer/Footer";
import Slideshow from "../Landingpage/ImgSlider";
import Videofile from "../Videos/H.mp4";
import { useTranslation } from "react-i18next";
import Viewall from "../Viewall/Viewall";
import Blogs from "../Blogs/Blogs";

export default function Videobox() {
  const { t } = useTranslation();
  return (
    <>
      {/* Video player */}
      <div className="v-c-box">
        <div className="video_box">
          <video autoPlay loop muted src={Videofile}></video>
        </div>
        {/* carouselExample */}

        <div className="car_box">
          <Slideshow />
          {/* <div
              id="carouselExampleIndicators"
              className="carousel slide"
              data-bs-ride="carousel"
            >
              <div className="carousel-indicators">
                <button
                  type="button"
                  data-bs-target="#carouselExampleIndicators"
                  data-bs-slide-to="0"
                  className="active"
                  aria-current="true"
                  aria-label="Slide 1"
                ></button>
                <button
                  type="button"
                  data-bs-target="#carouselExampleIndicators"
                  data-bs-slide-to="1"
                  aria-label="Slide 2"
                ></button>
                <button
                  type="button"
                  data-bs-target="#carouselExampleIndicators"
                  data-bs-slide-to="2"
                  aria-label="Slide 3"
                ></button>
              </div>
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <img src={Img1} className="d-block w-100" alt="..." />
                </div>
                <div className="carousel-item">
                  <img src={Img2} className="d-block w-100" alt="..." />
                </div>
                <div className="carousel-item">
                  <img src={Img3} className="d-block w-100" alt="..." />
                </div>
              </div>
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div> */}
        </div>
      </div>
      <h1
        style={{ color: "orangered", fontFamily: "cursive", marginTop: "20px" }}
      >
        {t("read")}
      </h1>
      <div
        className="grid_images"
        style={{
          // border: "1px solid red",
          height: "50px",
          width: "100%",
          marginTop: "50px",
        }}
      >
        <div className="image_box">
          {/* <a href="https://en.wikipedia.org/wiki/Ram_Mandir"> */}
          <div className="img_div">
            <Link to={BADRI_NATH}>
              <img className="imgbox" src={img_url2}></img>
              <h5 className="grid_temple_name">Badrinath Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">Badrinath, Uttarakhand</p>
            </Link>
          </div>
          {/* </a> */}
          {/* <a href={img_url3}> */}
          <div className="img_div">
            <img className="imgbox" src={img_url4}></img>
            <h5 className="grid_temple_name">Kashi Vishwanath Temple</h5>
            <Icon
              className="grid_temple_icon"
              icon="akar-icons:location"
              width="20"
            />
            <p className="grid_temple_location">Varanasi, Uttar Pradesh</p>
          </div>
          {/* </a> */}

          {/* <a href="https://en.wikipedia.org/wiki/Kailasanathar_Temple,_Kanchi"> */}
          <div className="img_div">
            <img className="imgbox" src={img_url5}></img>
            <h5 className="grid_temple_name">Golden Temple</h5>
            <Icon
              className="grid_temple_icon"
              icon="akar-icons:location"
              width="20"
            />
            <p className="grid_temple_location">Amritsar, Punjab</p>
          </div>
          {/* </a> */}
          {/* <a href="https://en.wikipedia.org/wiki/Ulagalantha_Perumal_Temple,_Kanchipuram"> */}
          <div className="img_div">
            <img className="imgbox" src={img_url6}></img>
            <h5 className="grid_temple_name">Vaishno Devi Temple</h5>
            <Icon
              className="grid_temple_icon"
              icon="akar-icons:location"
              width="20"
            />
            <p className="grid_temple_location">
              Vaishno Devi, Jammu & Kashmir
            </p>
          </div>
          {/* </a> */}
          {/* <a href="https://en.wikipedia.org/wiki/Tirunallar_Dharbaranyeswarar_Temple"> */}
          <div className="img_div">
            <img className="imgbox" src={img_url7}></img>
            <h5 className="grid_temple_name">Akshardham Temple</h5>
            <Icon
              className="grid_temple_icon"
              icon="akar-icons:location"
              width="20"
            />
            <p className="grid_temple_location">New Delhi, Delhi</p>
          </div>
          {/* </a> */}
          {/* <a href=""> */}
          <div className="img_div">
            <img className="imgbox" src={img_url8}></img>
            <h5 className="grid_temple_name">lotus Temple</h5>
            <Icon
              className="grid_temple_icon"
              icon="akar-icons:location"
              width="20"
            />
            <p className="grid_temple_location">New Delhi, Delhi</p>
          </div>
          {/* </a> */}
          {/* <a href="https://en.wikipedia.org/wiki/Vadakkunnathan_Temple"> */}
          <div className="img_div">
            <img className="imgbox" src={img_url9}></img>
            <h5 className="grid_temple_name">Dakshineswar Kali Temple</h5>
            <Icon
              className="grid_temple_icon"
              icon="akar-icons:location"
              width="20"
            />
            <p className="grid_temple_location">Kolkata, West Bengal</p>
          </div>
          {/* </a> */}
          {/* <a href="https://en.wikipedia.org/wiki/Jagannath_Temple,_Puri"> */}
          <div className="img_div">
            <img className="imgbox" src={img_url10}></img>
            <h5 className="grid_temple_name">Jagannath Temple</h5>
            <Icon
              className="grid_temple_icon"
              icon="akar-icons:location"
              width="20"
            />
            <p className="grid_temple_location">Puri, Orissa</p>
          </div>
          {/* </a> */}
        </div>
        <Link to="/view_temple">
          <button className="view_temple">View all</button>
        </Link>
        <Route path={VIEW_TEMPLE}>
          <Viewall />
        </Route>
      </div>
      <div className="for_blogs">
        <Blogs />
      </div>
      <div className="footer"></div>
    </>
  );
}
